import { useQuery } from '@tanstack/react-query';
import apiClient from '../api/apiClient';

interface ApplicationDetail {
  application: any;
  id: number;
  name_fa: string;
  name_en: string;
  version: string;
  download_count: number;
  logo: string | null;
  description: string;
  additionalInfo: string;
  images: string[];
}


const fetchApplicationDetails = async (
  publisherId: string,
  applicationId: string
): Promise<ApplicationDetail> => {
  const response = await apiClient.get(
    `/v2/publisher/applications/show?publisher_id=${publisherId}&application_id=${applicationId}`
  );
  return response.data;
};

// Custom Hook
const useApplicationDetails = (publisherId: string, applicationId: string) => {
  return useQuery({
    queryKey: ['applicationDetails', publisherId, applicationId],
    queryFn: () => fetchApplicationDetails(publisherId, applicationId),
    staleTime: 5 * 60 * 1000, 
    retry: 3,
    refetchOnWindowFocus: false,
  });
};

export default useApplicationDetails;
